export var SCREEN_BREAKPOINTS = {
  'phone': 0,
  'tablet': 544,
  'small-desktop': 768,
  'desktop': 992,
  'large-desktop': 1200
};